import ChargesTableFcl from "./charges-table-fcl.component";

export default ChargesTableFcl;
